// extracted by mini-css-extract-plugin
export var boxItems = "_cd-1";
export var boxItemsLg = "_cd-2";
export var button = "_cd-7";
export var buttonHoverless = "_cd-9";
export var buttonLg = "_cd-8";
export var filterGroupBox = "_cd-0";
export var icon = "_cd-3";
export var iconSecondary = "_cd-6";
export var iconWrapper = "_cd-4";
export var iconWrapperLg = "_cd-5";
export var truncatedLabel = "_cd-a";